import React from 'react';
import PropTypes from 'prop-types';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const NavigateToPageTemplate = ({
  collection,
}) => {
  const { setPageContentCollection } = usePageContentContext();

  useComponentDidMount(() => {
    setPageContentCollection(collection);
  });

  return <React.Fragment />;
};

NavigateToPageTemplate.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default NavigateToPageTemplate;
